
































































































































































































































































































































































//@ts-nocheck
//@ts-ignore
import { Component, Vue } from 'vue-property-decorator';


//@ts-ignore
import departamentos from '@/mixins/axios/general_departamentos'

//@ts-ignore
import pmd_arboles_problema from '@/mixins/axios/pmd_arboles_problema'

//@ts-ignore
import pmd_arboles_objetivos from '@/mixins/axios/pmd_arboles_objetivos'


//@ts-ignore
import dependencias from '@/mixins/axios/general_secretarias'

//@ts-ignore
import departamentos from '@/mixins/axios/general_departamentos'


//@ts-ignore
import TablePPoa from '@/components/tables/tablev1'
//@ts-ignore
import { email, required } from 'vuelidate/lib/validators';
//@ts-ignore
import Notiflix from "notiflix";
//import {Vuetable,VuetablePagination} from 'vuetable-2'
 import OrganizationChart from 'vue-organization-chart'
  import 'vue-organization-chart/dist/orgchart.css'
import VueHtml2pdf from 'vue-html2pdf'
import bootstrap from '!raw-loader!./bootstrap.css'
import { jsPDF } from "jspdf";

import VueAxios from "vue-axios";
import axios from "axios";
@Component({
  components: {
   OrganizationChart,VueHtml2pdf
  },

  data() {

    return {
        idmir:null,
        render_all:true,
        createMirv1:false,
       
          fullcard:false,
        type:'Creacion',
        problema_select:{
            problema:''
        },
        secretaria_show:"",
        dependencias:[],
        departamentos:[],
        problema:'',
        iddepartamento:0,
        idsecretaria:0,
        identificador:null,
departamento_show:"",

        causas_n:[],
        efectos_n1:[
           
            
        ],
         efectos_n2:[
            
           
        ],
         efectos_n3:[
          
           
        ],
        checked:{
            e1:[],
            e2:[],
            e3:[]
        },
        //datoa arbol de problema


         causas_n_problema:[],
        efectos_n1_problema:[
           
            
        ],
         efectos_n2_problema:[
            
           
        ],
         efectos_n3_problema:[
          
           
        ],
        problema_problema:'',
        iddepartamento_problema:0,
        idsecretaria_problema:0,
        identificador_problema:null,
    }
   
  },
  mixins:[pmd_arboles_problema,departamentos,dependencias,pmd_arboles_objetivos],
  methods:{ generateReport () {
            this.$refs.html2Pdf.generatePdf()
        },
async onClick() {
//avance financiero por linea de accion y a
//indicador fin proposito ,y linea de accion
    let headerr="<img src='data:image/jpeg;base64,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"+
    "AgBAJfKXh+aJkwGrDld7rt3r8VAr47tR3Iu8FmyyLGvjr+0M5VUdICA0DYGuzwOiJ1jOnuu1HrdW1DJdmXkcxjMGSVJE/L+UGhTinBARqvEIYvrJGt7yL+AXh0jGcS2NscEsnA1VKOs21pmewHSHsGUeZ+Sivro021LGLBp3cVm/JCqduKh4/ltawfmProoUmIyLo1EQsI8Hhbxqq/BSVeKVEvtyvd2XsPIKG+aR/E5SfHTRR8LUQZeTmaz5WcWtd5Gx+KnYY6znNKvGmXax36HlXBzwncosHQifwcWnxFx8FV4m37WuLzBX/c5v7EWQXB7lUpudAQVuPZV1o6Z7V32DyZ6Nnpp0PlP9Qw9niEnrr1Q8FZlKN2yOz8NTC98oJ6dmkEgiw179/oqutqnxSIjORa0NJHLGrnp4kis2DG+KbweP3HyXhmJ+dvQ2SYV5HdRUxXDZKaTm5LXsDobixVlDM2VuZpWTQuhdlcQ1tNJJpa6WL6uRze4m3ktb4mP4kubGSvZwrYedntraqOMZsr769IWPmFBkoIlXTQktxSZq62UaKPbiF2kkbmdo6Q+aiPw96cK3JseLxrxoqfJfUOL082kcrXH7t7O8jqoj4JGcSFhFVRS8DkJq1G8EBmW2Ndz1U6x6LOgO8e16/BXtHHkiT11OWxGbtJ15JoJGNTXeG/dHqVOahFa"+
    "hY7BYX9JrY2kXaz+Y7uZuHibBR6yTs4lXnoTaKLtJkTwTU3Rc4dMCAEAIAQEXFKMTwviO5zSPHqPnZeJGZ2q1TbBKsUjXp4KYjNGWOLXaFpIPeDYrn1Sy2U7lrkciKnidVgyWmzeK/RZs5BLS0tcBvPWPUBb6ebsn5l2IdfS/URZE33Quqzbp5+qiDe15ufIaKS/EHfinUr4sEYn+o6/sUdZtBVS+1M4Dg3oj01UV9RK7dxYxUFPHwsT96laTfVaSWCAlUztO5an7nlT2XkwX2xM+SraPvBzfS49QplA60yepXYozNTL6WU0xX5yhQbbwZ6Rx+6Wu9bfuode28K+hY4U/LUonO6GaKgOrIDhYlb0PZXYi3UHsXYf07JeBzOS/yfPP6vhy1LJObf4UiLoTkjUtkYMlHF2gu/MSR6WXOVrs07jpqFuWBvUuFFJZl22E+esk/ps3yH/a6KhblgQ5qvfmnd6FMpZDOWNuQOJsgGmNtgBwFlpNR2QDTyf0WaZ0pGjG2HvO/6Cr8QksxG8y1wmLNIr18P7mgKoOhIeLVgghfIfstNu/cB52WyJmd6NNNRL2Ubn8jIZpbXc48ST6ro0TwQ4/VVFaR5cST1m62mw1bklwvJA+cjWR2Vvus+Zv5BUuJS3ejE8C+wuLKxXr4j6q0tAQAgBACAEBlW3+HczVF4HRlGb+4aO/bzVN"+
    "WR5ZL8zrMJn7SDKu7dBaUQswQDbgOyUc8TZXSkh32WgC1t4JPWrCCja9qOVSkrMVfDIsbW7eKjLR7OUkW6IE8X9I+uimspom7IVEuIVEm7re2gh7U0HMVL2gWa7pt7ndXgbhVVTHkkVP2dLh0/bU7VXdNF/RUqOTT2pXa2Xh+xhSUAToNTwG/yWs8qthu2Y2YnEjJpP5YaQ4NPtHvHUFZ0lG/Mj3aWKWvxGLIsTNb6X8B7Vwc6RMXg5yCVvFjvO2nqtUzc0bk9DfTPyStd6oZCuZO1Ic46RW1ux6QgYi3og9q6T+nZLTPZzS/T/wCnI/1hDmp45OS26p/6K5defPjY6CLJFG37rGjyAXKyOzPVfU66JuViJyQkLwexJx/Y6Rz3SQuzFxLix2hueB3FW1NiDURGvS3qU1ThzlVXsW/oJ9TTPidle0tPAiytWva9LtW5UvY5i2clj3wqPNKOzXyR2xrdsMK1msEBpux1FzVKy+9/TP8Adu9LKirJM8q+mh1OHRdnAnNdS7UUnChyhV1mMhB1cc7u4bvX4Kyw+O6q8psXms1I08dTNsamszL1uPoFbtQo2pqU9NA6R7WN1LnBo7ybL05yNS6m1rVcqIh9DYTRNp4Y4m7mMDfIanzXLyPV71cvidbExGMRqeBLXg9ggBACAEAIBX5QsP52lzgdKI5v7To79j4KHWx5o78i0wi"+
    "fs58q7O0MtVOdWCAdeTyu0khJ3dNvcdHetj4qyoJN2fs57G4NWyp7L/Yc1ZFCUW02z/0zIQ4Mc24uRe4PV5qLU03a2strFjQV/wBLmRUuilH/AAJJ+O38p+ai93u8xY9+M8i9TtHsLICP57d/3T80XDnL+QXHGeReo5YNs9BTC7Rmf1vdqfDgpcFLHFtvzKqprpZ9FWyckLdSSEcIChxvamCnu1v8x/3QdB7zuruUKetjj0TVSxpcNlm+5dE5/wCDNXG5JVCp1SbESqGoWxh7Qh1jbsKt8GkyVjPW6dSl/qOHtMOk9LL0UqgV3h8qHnBdtWmzKgZTuztHR/uHV4Knnw5U1j6F1T4mi/bLp6jdDK14DmkOB3EG4VY5qtWyls1yOS6HdYMketoopm5ZGBw7Ru7j1L3HI+NbtWxrkiZIlnJcg4VsDCS97ZHtBsALA26zrw3KemJPtZUQrX4Sxy6OVELMbCRdcr/JvyWO8XeVDz3OzzL8Ho3Yan65JD+X5LHeMnJD0mEReZfj/A0MaAABuAsPBQFW5aolkshysGTKtpK7n6l7uoHK3ubp810FNH2caIclWTdrM5366CXis2aQ8Bp81Lamhpamgy8l+F89Wc4R0YRm/uOjf3PgoWIS5IsvMssNizy5uRsqoToQQAgBACAEAIDzniD2ua7UOBB7iLFYVLpZT01ytcjk8DEcRpDDK+"+
    "J29ji3wB0PlZc+9uRytXwO5hkSWNHp4oR14NhPwGu5iojk6r2d7rtD8/BbYJMkiOI1ZD20DmePh7oayr84kEAIAQE+F1wEBDxTF4aZt5HWPU0auPcFpmnZEl3KSKellnWzE/fgImNbVzT3az+WzgD0j3u+Sp5658mjdEOipcMih1d9y/AvqEWQICPVEaL2wyhFkbcEdilU8nZytfyVF+TTVxdtA+Pm1U+CmX0s+LggJ2F4vPTG8byB1tOrT3haZqdkqfchvhqZIVu1R5wba6CazZP5T+09A9zurxVPPQPj1bqnyXVPiMcmjtF+BiCgFgMeHR5Y2jjr5oCSgBAcICs2lruYpnu6yMre92g+a300faSIhFrZuyhc7x2T9mS1MuRhdwHr1LoUS6nJogsErabTZ+THC+Yog8jpTHOfd3M9NfFUFfLnltyOiw6LJDfnqNygk8EAIAQAgBACAEBm/KVh+SZkwGjxlPvN3eY+Cqq+OzkdzOlwWfNGsa+H8KJqgF0cIBuottnRxtY6LMWtAzZrXtpdWDK9WtRFQpJcFR71cjrX8LHuNvP/AAfrXrvD/iau4/8An8HI28H4B/ME7wTyjuNfP8HYbeN/Ad+YLPeCeUx3G7zp0OJtuXvYWwx5D95xBI7gtM2IOtZiWNsODNa68jr+iC5NK57i57i5x3km5VY5yuW6qW7WtalmpZDosHo4c4De"+
    "sogI0lRfcvaM5nqx4r2ZPKpl5veDci4Ft449ysqLC5qrVNG81/sU2J45TUP2uXM7yp/fkVTjckrvWNytRvI+VyPzvV1rXVVOF6PAIDhAXmA7QVEDmsac7CQMjtQO49SiT0kcuq6LzJcFbJClk1Tko/DbuT8Fn5j8lD7ub5jf3w/yJ1Of47k/Ab+Y/JO7m+Yz3w/yJ1Of47k/Ab+Y/JO7m+Yd8P8AInUP47k/Ab+Y/JY7ub5h3w/yJ1KnH9oX1Ya0sDA0k2BJudw8tfNSKelSFVVFuRKutdUIiKlrCjjk2gZx1P7Ka1CI0iYPQGonjhG97wO4dZ8BdYlfkYruRvijWR6NTxPoWCIMa1rRYNAAHYBYLl1VVW6nWNRESyHosGQQAgBACAEAIAQFJtjh30ikeAOk3pt72/8AV1Hqo88aoTsOn7KdFXZdF/ZkCozsQQAgBACAEB605s5eXJoYUlrUeTwkqAN2q9ozmZRCO5xO9e0Sx6JeGYXNUuyxMLj1n7I7z1LbHE6RbNQ0z1EcLcz1saDgGxEMNnzWlfw+wPDr8VZw0TW6u1U52rxaST7Y/tT5LvGMDpqtmSaMEDcRo5vukblZRTPiW7FKOaBkyWehl203J/UU13w3mj36DptHa3r7wrmnr2SaO0X4KOow98erNU+RNIU8rzhAcoCdg0d5L8BdeXbHl2xfLWawQyCAEAIYFqumzyOPg"+
    "O4LaiaG1Nh45I8LzzSVBGjBkb7zt/p8VW4lLZqM5lthcV3q/kasqUvAQAgBACAEAIAQAgOCLoDGNoqD6PUyR9Qddvuu1HxVBPHkkVp21HN20LX/APblatRJBACAEAIDlpsUB2klLvksI1EMWCGJz3BrGlzjuAFyfBekRVWyGHORqXctkHXAdg3Os+qNh+G06/3O6u4KwhoVXWToUlVjCJ9sPX/A+UlJHC0MjaGtHUBZWLWo1LIhQSSOkdmet1PZejwCAEAsbS7E01ZdwHNS/faN/vt+18VMgrJItN05EKooY5tdl5mVbQbMVVE7+ay7L6SN1YfHqPYVcw1McqfauvIo56WSFfuTTmUykEck0dYYr2AN+N15VLmFS5I/zh/3W+vzWMhjKH+cP+631+aZEGUP84k+631+aZUGVDj/ADiTg31+aZUGVDh+LSEEWbr3/NZyoMqFevR6N32Gwv6NRRtIs5w5x3e/X4WXN1cvaSqv6Ono4uzhRP2X6jEoEAIAQAgBACAEAIAQCZt9gEk7o5IW5nAFrhcDTe06kdvmoFZA56o5pdYVWMiRzJF03QUP4Xrfwv1s/wCSg/TS8v4LjvCn83wv+Dqdmqz8L9bP+SfTycjP19P5vhf8HB2dq/wv1s+ax9PJyM/XQeb4X/B1Oz9V+H+pnzTsJORn62DzfCnX/Iqn8P8AUz5rHYv5GfrIfN8KdTg1R9z"+
    "9TfmnYv5GfqoufwpaYFsfPUm7iI2A2JuC49gA/dbYaR7110Qi1WJxwpZuqmi4PgcFI20TNet51ce8q1ihZGn2oc3UVcs63ev68CyW0jAgBACAEAIDpLE17S1wDmnQgi4PeFlFVFuhhURUsogbTcm7H3kpCGO38272D7p+z8FZ0+IqmkmvqVVRhqO+6PT0E8bC4j+CP9yP/kp31sPP4Ur/AKCfl8odhsHiP4Tf9xnzWProefwZ7vn5fKHcbAYj+G3/AHGfNPr4efwZ7vn5fJ2HJ7iP3Gf7jVj6+Hn8Ge7p+Xydhyd4h92P/cCx3hD69B3bP6dTsOTjEOEf+5/0neMPr0M92z+nUmYVycVYmjM3N82HtL7PuS0G5AFuvctcmIx5Vy3ubIsNkzpmtY1sKkL4EAIAQAgBAf/Z' style='width:50px;height:50px;position:fixed;margin-left:10px' /><h1 style='width:100vw;margin-left:0px;text-align:center;left:0px;top:0px;font-size:15px;float:left;position:fixed'> "+"Arboles"+"</h1><img src='http://2.bp.blogspot.com/-fWxHGhzQD6g/T9J-L1F2ukI/AAAAAAAAAMQ/2EwSbOQ4l94/s400/Escudo+de+Torreon.jpg' style='width:50px;height:50px;position:relative;float:left;margin-left:10px' >";
let footer="<h1 style='font-size:10px;position: absolute;width:100%;text-align:left;bottom: 5px;'> DESARROLLO ECONOMICO<br>DIRECCION DE CALIDAD E INNOVACION GUBERNAMENTAL </h1>";

       var sTable = "<body>"+document.getElementById('contentarbol').innerHTML+"</body>";
       var pdf="<style>"+bootstrap+"</style>";
       //let params="generate?html="+pdf+sTable+"&landscape=true&format=A2&apiKey=VoCkYiJEfM2JtT1noOjHEb7h8vxPEbXE8TISZkIVhY3R2wEkzXKh0XVoZqdpiOXZ";
       //let res = encodeURI(params);
              await axios({
                    url: "https://api.html2pdf.app/v1/generate",//this.$store.state.baseapi+"pdf",
                    method: 'POST',
                    data:{
                    html:pdf+sTable,
                    //headerTemplate:headerr,
                    //footerTemplate:footer,
                    landscape:true,
                    marginTop:45,
                    marginLeft:45,
                    marginRight:45,
                    marginBottom:45,
                    format:'A2',
                    apiKey:'VoCkYiJEfM2JtT1noOjHEb7h8vxPEbXE8TISZkIVhY3R2wEkzXKh0XVoZqdpiOXZ'
                    },
                    
                    responseType: 'blob'
                }).then((response) => {
                     var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                     var fileLink = document.createElement('a');

                     fileLink.href = fileURL;
                     fileLink.setAttribute('download', 'file.pdf');
                     document.body.appendChild(fileLink);

                     fileLink.click();
                });
          },
   async createPDF() {



        var sTable = document.getElementById('contpdf').innerHTML;

      
       // console.log(style)

        // CREATE A WINDOW OBJECT.
        var win = window.open('', '', 'height=700,width=900');

        win.document.write('<html><head>');
        win.document.write('<title>pdfrrles</title>');   // <title> FOR PDF HEADER.
        //win.document.write(style);    
              // ADD STYLE INSIDE THE HEAD TAG.
        win.document.write('</head>');
        win.document.write('<body>');
        win.document.write(sTable);         // THE TABLE CONTENTS INSIDE THE BODY TAG.
        win.document.write('</body></html>');

       	// CLOSE THE CURRENT WINDOW.
  win.document.close();
        win.print();    // PRINT THE CONTENTS.
    },



async getObjetivo() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
id:this.$store.state.arbol_problema.idobjetivos,

};

let data= await this.GET_PMDID_ARBOLES_OBJETIVOS(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                       //this.problema_select=response; 
                       this.efectos_n1=JSON.parse(response.fines)[0];
                       this.efectos_n2=JSON.parse(response.fines)[1];
                       this.efectos_n3=JSON.parse(response.fines)[2];
                        this.causas_n=JSON.parse(response.componentes);
                         this.problema=response.objetivo;
                         this.idmir=response.idmir;
//console.log(response)
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},

async getArbol() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')
let data2={
id:this.$store.state.arbol_problema.id,

};


let data= await this. GET_PMDID_ARBOLES(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                       //this.problema_select=response; 
                       this.idsecretaria_problema=response.idsecretaria;
                       this.departamento_show=response.departamento;
                       this.secretaria_show=response.secretaria;
                       
                       //this.getDataDepartamentos( response.idsecretaria);
                        this.iddepartamento_problema=response.iddepartamento;
                        this.identificador_problema=response.identificacion;
                       this.efectos_n1_problema=JSON.parse(response.efectos)[0];
                       this.efectos_n2_problema=JSON.parse(response.efectos)[1];
                       this.efectos_n3_problema=JSON.parse(response.efectos)[2];
                        this.causas_n_problema=JSON.parse(response.causas);
                         this.problema_problema=response.problema;
//console.log(response)
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},

async getDataDepartamentos(id) {
  
 this.$root.$emit('loading', true);
 console.log('muestra dep')

let data2={
iddependencia:id,
idmunicipio:this.$store.state.user.usuario.id_municipio

};

let data= await this.GET_GENERAL_DEPARTAMENTOS(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.departamentos=response;
console.log(this.departamentos)
//this.departamento_show=this.departamentos.filter(item => item.id == this.iddepartamento_problema)[0]['departamento']
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);
 console.log('oculta dep')
                    //loading.close();
                });
},


  },
  created(){
      
  },
  mounted(){

this.getObjetivo();
     
   this.getArbol();
   
  }
})
export default class Home extends Vue {}

